import { useRef } from "react"
import Icon from "~/components/Icon"

interface SelectStudyButtonProps {
  userId: string
  organisationName?: string
  studyName: string
  studyDescription?: string
  path: string
}

export default function SelectStudyButton({
  userId,
  organisationName,
  studyName,
  studyDescription,
  path
}: SelectStudyButtonProps) {
  const formRef = useRef<HTMLFormElement>(null)

  const submitForm = () => {
    const csrfTokenElement = document.querySelector(
      'meta[name="csrf-token"]'
    ) as HTMLMetaElement

    if (csrfTokenElement && formRef.current) {
      const csrfToken = csrfTokenElement.getAttribute("content")

      /* istanbul ignore next */
      if (csrfToken) {
        const csrfInput = document.createElement("input")
        csrfInput.setAttribute("type", "hidden")
        csrfInput.setAttribute("name", "authenticity_token")
        csrfInput.setAttribute("value", csrfToken)
        formRef.current.appendChild(csrfInput)
        formRef.current.submit()
      }
    }
  }

  return (
    <form
      ref={formRef}
      action={path}
      method="post"
      role="form"
      onSubmit={submitForm}
      className="w-full flex justify-center items-center"
      data-testid="SelectStudyButton-form"
    >
      <input type="hidden" name="user_id" value={userId} />
      <button
        type="submit"
        className="w-full bg-white rounded-xl p-4 flex items-center gap-4 text-left hover:shadow-md transition-shadow"
      >
        <div className="flex items-center w-full justify-end">
          <div className="flex flex-col gap-1 flex-1">
            {organisationName && (
              <p className="text-sm leading-[140%] text-primary-700">
                {organisationName}
              </p>
            )}
            <h2 className="text-lg font-bold text-black">{studyName}</h2>
            {studyDescription && (
              <p className="text-sm text-neutral-700 mr-auto">
                {studyDescription}
              </p>
            )}
          </div>
          <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center bg-primary-500">
            <Icon name="arrowRight2" className="w-4 h-4 text-white" />
          </div>
        </div>
      </button>
    </form>
  )
}
